export default {
	methods: {
		/**
		 * Mostra Erro
		 * @param Array error
		 **/
		showErrorLogin(error) {
			this.$helper.closeLoader();

			if(typeof error != "undefined"){
				var responseData = null;
				if(typeof error.response != "undefined"){
					if(typeof error.response.data != "undefined"){
						responseData = error.response.data;
					}
				}

				this.hashlogin = null;
				this.$cookie.remove("hashlogin");

				if( this.$route.path == "/login_super" &&
					responseData != null &&
					responseData.ERRO.toLowerCase().indexOf('token') !== -1){

					this.needGToken = true;
				}
			}

			this.error_message(error);
		},

		/**
		 * Mensagens que podem ser dos tipos "success", "warning" ou "error"
		 * @param String Title
		 * @param String msg
		 * @param String type
		 **/
		message(title, msg, type) {
			msg = this.convertReturnMessage(msg);

			this.$swal({
				title: title,
				text: msg,
				type: type
			});
		},

		/**
		 * Tratamento para retorno de mensagem de erro
		 * @param Array type
		 **/
		error_message(error) {
			this.$helper.closeLoader();

			let title = this.$t("message_title_error");
			let msg = "Error Processing Request";

			if (typeof error.response == "undefined") {
				// erro não tratável. Um problema de sintaxe ou de server não retornando um json
				this.message(title, msg, 'error');
				return;
			}

			if (typeof error.response.data == "undefined") {
				if (typeof error.ERRO != "undefined") {
					msg = error.ERRO;
				}
			} else {
				if (typeof error.response.data.ERRCODE != "undefined") {

					// Erro de login - usuário não logado
					if (error.response.data.ERRCODE == 7) {
						this.$helper.pushRouteTo({ name: "Login" });
						return;
					} else if (error.response.data.ERRO.indexOf("Your username has been locked") >= 0) {
						// Caso do usuário que teve que confirmar a senha na modal, porém bloqueou a senha
						this.message(title, error.response.data.ERRO, 'error');

						this.$helper.pushRouteTo({ name: "Login" });
						return;
					} else if (error.response.data.ERRO.indexOf("Permission denied") >= 0) {
						// erro de permissão // volte uma casa
						clearTimeout(controlTimeout);
						controlTimeout = window.setTimeout(function () {
							this.message(title, error.response.data.ERRO, 'error');

							router.go(-1);
						}, 100);

						return;
					} else {
						msg = error.response.data.ERRO;
					}
				} else if (typeof error.response.data.error != "undefined") {
					msg = error.body.error;
				}
			}

			this.message(title, msg, 'error');
		},

		/**
		 * Converte as possíveis mensagens de retorno da Api
		 * @param String msg
		 **/
		convertReturnMessage(msg) {
			switch (msg) {
				case "error_msg_username_password":
					msg = this.$t("login_msg_invalid_username_password");
					break;
				case "error_msg_username_password_token":
					msg = this.$t("login_msg_invalid_username_password_token");
					break;
				case "error_msg_all_fields_are_required":
					msg = this.$t("login_msg_all_fields_Are_required");
					break;
				case "error_msg_same_password_confirmation":
					msg = this.$t("login_msg_same_password_confirmation");
					break;
				case "error_msg_invalid_digits_password":
					msg = this.$t("login_msg_invalid_digits_password");
					break;
				case "error_reset":
					msg = this.$t("login_msg_error_reset");
					break;
				case "error_username_locked":
					msg = this.$t("login_msg_username_locked");
					break;
				case "error_invalid_access_code":
					msg = this.$t("login_msg_invalid_access_code");
					break;
				default:
					break;
			}

			return msg;
		}
	}
}